var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.64 4.5l8.33 4.7c.28.16.64.23 1 .23.37 0 .73-.07 1.01-.23l8.34-4.7c.54-.3 1.05-1.5.06-1.5H.58c-1 0-.48 1.2.06 1.5zm18.93 2.57c-.62.34-8.2 4.5-8.59 4.7-.37.2-.64.23-1 .23-.37 0-.63-.02-1-.23-.39-.2-7.93-4.36-8.55-4.7C0 6.83 0 7.1 0 7.32v8.51C0 16.33.63 17 1.11 17H18.9c.48 0 1.11-.68 1.11-1.17v-8.5c0-.22 0-.5-.43-.26z",
    fill: "currentColor"
  })));
}
export default SvgEmail;